import { SERVER_DATE_TIME_FORMAT } from "@constants/date-formats";
import { getWorkflowReportCompletionRatesOverTimeReduxRequest } from "@redux-requests/workflow-report/get-workflow-report-completion-rates-overtime";
import { getWorkflowReportSearchResultsCompletionRatesReduxRequest } from "@redux-requests/workflow-report/get-workflow-report-search-results-completion-rates";
import { getWorkflowReportSearchResultsFraudReduxRequest } from "@redux-requests/workflow-report/get-workflow-report-search-results-fraud";
import { getWorkflowReportSearchResultsPassRateAndOverTimeReduxRequest } from "@redux-requests/workflow-report/get-workflow-report-search-results-pass-rate-and-over-time";
import { getWorkflowReportSearchResultsStepByStepReduxRequest } from "@redux-requests/workflow-report/get-workflow-report-search-results-step-by-step";
import { getWorkflowReportSearchResultsVolumeByAppIdReduxRequest } from "@redux-requests/workflow-report/get-workflow-report-search-results-volume-by-app-id";
import { getWorkflowReportSearchResultsVolumeByCountryReduxRequest } from "@redux-requests/workflow-report/get-workflow-report-search-results-volume-by-country";
import { generateQueryParameters } from "@utils/query-parameter-util";
import endOfDay from "date-fns/endOfDay";
import format from "date-fns/format";
import startOfDay from "date-fns/startOfDay";
import { Dispatch } from "redux";

export const getWorkflowReportSearchResultsReduxRequest = (dispatch: Dispatch) => async (
    workflowId: string,
    appId: string,
    country: string,
    startDate: Date,
    endDate: Date
) => {
    const queryParameters = generateQueryParameters({
        workflowID: workflowId,
        appID: appId,
        country: country,
        startDate: format(startOfDay(startDate), SERVER_DATE_TIME_FORMAT),
        endDate: format(endOfDay(endDate), SERVER_DATE_TIME_FORMAT),
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        dateFormat: SERVER_DATE_TIME_FORMAT
    });

    getWorkflowReportSearchResultsPassRateAndOverTimeReduxRequest(dispatch)(queryParameters);
    getWorkflowReportCompletionRatesOverTimeReduxRequest(dispatch)(queryParameters);
    getWorkflowReportSearchResultsCompletionRatesReduxRequest(dispatch)(queryParameters);
    getWorkflowReportSearchResultsFraudReduxRequest(dispatch)(queryParameters);
    getWorkflowReportSearchResultsPassRateAndOverTimeReduxRequest(dispatch)(queryParameters);
    getWorkflowReportSearchResultsStepByStepReduxRequest(dispatch)(queryParameters);
    getWorkflowReportSearchResultsVolumeByAppIdReduxRequest(dispatch)(queryParameters);
    getWorkflowReportSearchResultsVolumeByCountryReduxRequest(dispatch)(queryParameters);

};